export const URL_POST_FORM = `${process.env.PUBLIC_API_GATEWAY}/acquisition/forms`
export const STATUS_CODE_CREATED = 201

export const SITE_SECTIONS = {
  CARDS: 'CARDS',
  MENU: 'MENU',
  SUBMENU: 'SUBMENU',
  FOOTER: 'FOOTER',
}
